export const YLOPO_BASE_URL = `https://homebot.ylopo.com/search`
export const YLOPO_SIMILAR_HOMES = 'similarHomes'
export const YLOPO_EQUITY_SMART_SEARCH = 'ylopoEquitySmartSearch'
export const YLOPO_MAX_PRICE_MULTIPLIER = 1.2
export const YLOPO_MIN_PRICE_MULTIPLIER = 0.8

export const ylopoSearchCriteria = {
  EQUITY_SMART_SEARCH_SIMILAR_HOME_DISTANCE: 10,
  SIMILAR_HOME_DISTANCE: 3,
  SIMILAR_HOME_LIMIT: 20,
  SIMILAR_HOME_MAX_PRICE_MULTIPLIER: 1.2,
  SIMILAR_HOME_MIN_PRICE_MULTIPLIER: 0.8
}
